// 先导入
import axios from "axios";
import { message } from "antd";

// 获取当前环境
const isDev = process.env.NODE_ENV === "development";

// 基础配置
const ins = axios.create({
  // 为真就是开发环境，否则生成环境
  // baseURL: isDev ? 'http://58.221.151.226:8299' : "http://58.221.151.226:8299",   // 本地服务器ip http://192.168.5.2:5000
  baseURL: isDev ? 'http://38.60.169.21:8299' : "http://58.221.151.226:8299",   // 本地服务器ip http://192.168.5.2:5000
  // baseURL: isDev ? 'https://carhire.ecarro.cn' : "https://carhire.ecarro.cn",   // 本地服务器ip http://192.168.5.2:5000
  timeout: 60000,
});

// 请求拦截器
ins.interceptors.request.use(
  (config) => {
    // 判断如果没有 token 就直接叫用户去做登录
    // 做登录的验证 -- token
    let token = localStorage.getItem("token");
    // config.headers["Content-Type"] = " text/json";
    config.headers.Authorization = token;
    const arr = ["login", "reset", "register", "success", "verify_code", "forget", "sendEmailCode", "invite"]
    if (!arr.some(item => new RegExp(item).test(config.url))) {
      if (!token) {
        window.location.href = window.location.origin + "/login";
      }
    }
    return config;
  },
  (error) => Promise.reject(message.error(error))
);

// 响应拦截器
ins.interceptors.response.use(
  (response) => {
    if (!response.data) {
      message.error("请求失败：" + (response.message || "未知错误"));
      // window.location.href = window.location.origin + "/#/login";
    } else if (response.data.code === 403) {
      message.error("对不起，您没有权限！");
      setTimeout(() => {
        window.location.href = window.location.origin + "/login";
      }, 300);
    } else if (response.data.code === 401) {
      message.error("登录已过期，请重新登录！");
      setTimeout(() => {
        window.location.href = window.location.origin + "/login";
      }, 300);
    } else if (response.data.code === 404) {
      // window.location.href = window.location.origin + "/#/error";
      message.error("对不起，页面不存在！");
    } else if (response.data.code === 429) {
      // if (!error.request.responseURL.split("/")[5].split("?")[0] == "order") {
      //   message.warning(t("drawer.upload"), 5);
      // }
    } else {
      // message.error(error.message);
      console.log(response);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 自定义各种数据请求 axios
export default function request(config) {
  // 解构出请求配置
  const { url = "", method = "get", data = {}, headers = {} } = config;

  switch (method.toUpperCase()) {
    case "GET":
      return ins.get(url, { params: data });
    case "POST":
      // 表单提交
      if (headers["content-type"] === "application/x-www-form-url-encoded") {
        // 格式化数据 也可以使用第三方的 qs
        const p = new URLSearchParams();
        for (const key in data) {
          p.append(key, data[key]);
        }
        return ins.post(url, p, { headers });
      }
      // 文件提交
      if (headers["content-type"] === "multipart/form-data") {
        const p = new FormData();
        for (const key in data) {
          p.append(key, data[key]);
        }
        return ins.post(url, p, { headers });
      }
      // 默认普通 POST 请求
      return ins.post(url, data, { headers });
    // 修改数据 -- 数据的更新
    case "PUT":
      if (headers && headers['Content-Type'] === 'application/x-www-form-urlencoded') {

        // 使用 URLSearchParams 序列化数据
        const params = new URLSearchParams();
        for (const key in config.data) {
          if (Object.hasOwnProperty.call(config.data, key)) {
            const value = config.data[key];
            // 如果值是数组，需要单独处理，后端通常期望 key=value1&key=value2 的形式
            if (Array.isArray(value)) {
              value.forEach(item => params.append(key, item));
            } else {
              params.append(key, value);
            }
          }
        }
        return ins.put(url, params.toString());
      } else {
        return ins.put(url, data);
      }
    case "DELETE":
      // 删除数据
      return ins.delete(url, data);
    case "PATCH":
      // 更新局部资源
      return ins.patch(url, data);
    default:
      break;
  }
}
